var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41.5 41.5",
    style: {
      enableBackground: "new 0 0 41.5 41.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C4C4C4;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 20.75,
    cy: 20.75,
    r: 20.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.85,23.01c0.69,0,1.25-0.56,1.25-1.25v-7.85c0-0.69-0.56-1.25-1.25-1.25H15.2c-0.69,0-1.25,0.56-1.25,1.25 v2.15h2.33c1.93,0,3.5,1.57,3.5,3.5v3.45H28.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.83,18.11h-5.42c-0.5,0-0.91,0.41-0.91,0.91v10.3c0,0.5,0.41,0.91,0.91,0.91h5.42 c0.5,0,0.91-0.41,0.91-0.91v-10.3C17.74,18.51,17.33,18.11,16.83,18.11z M15.58,28.52c0,0.09-0.07,0.17-0.17,0.17h-2.59 c-0.09,0-0.17-0.07-0.17-0.17v-0.82c0-0.09,0.07-0.17,0.17-0.17h2.59c0.09,0,0.17,0.07,0.17,0.17V28.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.65,25.13H20.26c-0.19,0-0.35,0.16-0.35,0.35v1.45c0,0.19,0.16,0.35,0.35,0.35h10.39 c0.19,0,0.35-0.16,0.35-0.35v-1.45C31,25.29,30.85,25.13,30.65,25.13z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon10);
export default __webpack_public_path__ + "static/media/icon_10.fb1ace29c08ec64d33555b24317f4c15.svg";
export { ForwardRef as ReactComponent };